export default __webpack_public_path__ + "static/media/dollor.d8985b7b.svg";